import { Auth } from '@jg/auth';
import Preact from 'preact';
import LoggedIn from './LoggedIn';
import LoggedOut from './LoggedOut';
import { UserContent } from '../../content/content';
import { Branding } from '../../content';

interface Props {
  content: UserContent;
  showPip: boolean;
  auth: Auth;
  handleShowModal: (showModal: boolean) => void;
  branding?: Branding;
}

const User: Preact.FunctionalComponent<Props> = ({
  auth,
  content,
  showPip,
  handleShowModal,
  branding,
}) =>
  auth.isUserLoggedIn() ? (
    <LoggedIn
      auth={auth}
      menu={content.userMenu}
      showPip={showPip}
      handleShowModal={handleShowModal}
      branding={branding}
    />
  ) : !auth.isGuest() ? (
    <LoggedOut {...content.loggedOut} />
  ) : null;

export default User;
